module.exports = __webpack_public_path__ + "img/done_o.64d70a17.png";